import React from "react"
import { MarkupComponents } from "@indeed/frontend-markup-react-components"
import { Text } from "@indeed/ifl-components"
import { useDateFormatter } from "../../common/hooks/useDateFormatter"
import { useI18n } from "../../common/utils/i18n-context"
import { useAppSelector } from "../../common/utils/redux-helpers"
import { isPausedSelector, effectiveDateSelector } from "./pause-slice"

export const PauseSubHeader: React.FC = () => {
    const pauseEndDate = useAppSelector(effectiveDateSelector)
    const dateFormatter = useDateFormatter()
    const isPaused = useAppSelector(isPausedSelector)
    const { gettext } = useI18n()

    return (
        <Text data-testid="effective-date-text">
            {!isPaused ? (
                gettext("It can take up to 24 hours for this change to take effect.")
            ) : (
                <MarkupComponents
                    components={{
                        strongText: "strong",
                    }}
                >
                    {gettext("Communications will resume on [{0}|strongText]. It can take up to 24 hours for this change to take effect.", [
                        dateFormatter(pauseEndDate, { dateStyle: "long" }),
                    ])}
                </MarkupComponents>
            )}
        </Text>
    )
}
